import { gql, useLazyQuery } from '@apollo/client'

import agentClient from '@/lib/apollo/client/agent'
import type { WrappedUseLazyQuery } from '@/lib/apollo/types'

const getSubjectQuery = gql`
  query ($customerId: String!, $subjectId: String!) {
    getSubject(customerId: $customerId, subjectId: $subjectId) {
      id
      applicationId
      customerId
    }
  }
`

export type QueryVars = {
  customerId: string
  subjectId: string
}

export type GetSubjectData = {
  getSubject: {
    id: string
    applicationId: string
    customerId: string
  }
}

export const useGetSubjectQuery: WrappedUseLazyQuery<
  GetSubjectData,
  QueryVars
> = options =>
  useLazyQuery<GetSubjectData, QueryVars>(getSubjectQuery, {
    ...options,
    client: agentClient,
  })
